import { Injectable, inject } from '@angular/core';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { Assets } from '../shared/assets';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class IconService {
  private faIconLibrary = inject(FaIconLibrary);
  private matIconRegistry = inject(MatIconRegistry);
  private sanitizer = inject(DomSanitizer);

  registerIcons(): void {
    const allIcons = Object.values(Assets.FA_ICONS).map((fa) => fa.icon);
    this.faIconLibrary.addIcons(...allIcons);

    const svgIcons = Object.values(Assets.ICONS);
    svgIcons.forEach((icon) => {
      this.matIconRegistry.addSvgIcon(
        icon.name,
        this.sanitizer.bypassSecurityTrustResourceUrl(icon.url),
      );
    });
  }
}
